import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ExtractedTableRemovalService {
  destroyedTable$ = new Subject<{ tableId: string }>();

  destroyTable(tableId: string) {
    this.destroyedTable$.next({ tableId: tableId });
  }
}
